export enum EmailTemplateCategory {
  NewInvoice = 0,
  InvoiceReminder,
  SendQuote,
  QuoteGeneral,
  OperationalFileGeneral,
  InvoiceReminders,
}